<app-new-proposal-blank *ngIf="contest && contest.closing_date === null && contest.decision_table" [contest]=contest [decision_table]="contest.decision_table" [framework]="contest.decision_table.framework">
